import { Caption, Body1, Pill } from "@coherehealth/common";
import { Box } from "@mui/material";
import { useClinicalReviewStyles } from "../caseCompletePageStyles";
import { CaseCompletePageT } from "../caseCompletePageUtils";

export const PillSection = ({ pillDataDisplay }: CaseCompletePageT) => {
  const classes = useClinicalReviewStyles();
  return (
    <Box className={classes.outcomeCaseTrackingBox}>
      <Caption className={classes.caption}>{pillDataDisplay?.caption}</Caption>
      <Body1 className={classes.body1}>
        <Pill label={pillDataDisplay?.label || ""} variant={pillDataDisplay?.pillType || "warning"} />
      </Body1>
    </Box>
  );
};
